export const CASHFLOW_TYPE_PT: Record<string, string> = {
  PLANNED: "Previsto",
  ACTUAL: "Realizado",
};

export const CASHFLOW_ORIGIN_PT: Record<string, string> = {
  MANUAL: "Manual",
  PARTNER: "Socio",
  PAYABLE: "Contas a pagar",
  RECEIVABLE: "Contas a receber",
};

export const CASHFLOW_SOURCE_TYPE_PT: Record<string, string> = {
  PartnerContribution: "Aporte de socio",
};
